import styled from 'styled-components';

import AIButton from 'components/shared/ai/AIButton';
import Jumbotron from 'components/shared/ai/Jumbotron';
import Tooltip from 'components/shared/Tooltip';
import { ReviewType } from 'models/Review';
import { BodySmallBold } from 'styles/typography';
import AISummaryIcon from 'svg/AISummaryIcon';

const getBodyTextForSummaryType = (type: ReviewType, filesCount: number) => {
  switch (type) {
    case ReviewType.AUTHORIZATION:
      return (
        <>
          <strong>{filesCount ?? '--'} files</strong> are available to summarize for review
        </>
      );
    case ReviewType.REFERRAL:
      return (
        <>
          <strong>{filesCount ?? '--'} files</strong> are available for referral summarization
        </>
      );
  }
};

type SummaryEmptyStateProps = {
  filesCount?: number;
  summaryType: ReviewType;
  onSummarizeFiles?: () => void;
  disableSummaryButton?: boolean;
  tooltipText?: string;
};

export default function SummaryEmptyState({
  filesCount = 0,
  summaryType,
  onSummarizeFiles,
  disableSummaryButton = false,
  tooltipText,
}: SummaryEmptyStateProps) {
  return (
    <StyledJumbotron>
      <JumbotronContentContainer>
        <AISummaryIcon />
        <BodySmallBold>AI Summary</BodySmallBold>
        <BodyText>{getBodyTextForSummaryType(summaryType, filesCount)}</BodyText>
      </JumbotronContentContainer>
      <Tooltip text={tooltipText || ''} disabled={!tooltipText}>
        <div>
          <AIButton disabled={disableSummaryButton} onClick={onSummarizeFiles} data-cy='SummarizeFiles'>
            Summarize Files
          </AIButton>
        </div>
      </Tooltip>
    </StyledJumbotron>
  );
}

const StyledJumbotron = styled(Jumbotron)`
  height: 220px;
  gap: 24px;
  padding: 24px;
`;

const JumbotronContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const BodyText = styled.p`
  font-size: 12px;
  line-height: 12px;
`;
